import React, {type ComponentType} from 'react';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function wrap<T>(Component: T): T {
  const C: any = Component;
  return ((props: T) => <C {...props} />) as any as T;
}

export type GetProps<C> = C extends ComponentType<infer P> ? P : never;
